import { Heading } from "../../components/heading/Heading"
import { P } from "../../components/p/P"
import { Card, CardsWrapper, CompletedProjectsWrapper, Image, ViewMoreButton } from "./styles"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons"
import { projectsData } from "../../util/ourProjects/ourProjects"
import { Link } from "react-router-dom"

export const CompletedProjects = () => {

    return (
        <CompletedProjectsWrapper>
            <Heading level={2}>Completed Projects</Heading>
            <P>A Showcase of Completed Developments, History of Excellence, Previous Achievements, Explore Our Completed Works, Experience Matters, Review Our Accomplishments, Our Legacy, Proven Success</P>
            <CardsWrapper>
                {
                    projectsData.slice(0,4).map((item, idx) => (
                            <Card key={idx}>
                                <Image src={item.img} />
                                <Heading level={3}>{item.title}</Heading>
                                <P>{item.address}</P>
                                <P style={{'color': '#3374f0'}}>{item.tag}</P>
                            </Card>
                    ))
                }
            </CardsWrapper>
            <Link to='/our-projects'>
                <ViewMoreButton>
                    <span>View More &nbsp;</span>
                    <FontAwesomeIcon icon={faArrowRight} />
                </ViewMoreButton>
            </Link>
        </CompletedProjectsWrapper>
    )
}